type Props = {
    title : string
    subTitle : string
}

const Heading = (props:Props) => {
    return(
        <hgroup className='text-center text-bold max-w-2xl mx-auto'>
            <h2 className='text-4xl md:text-8xl uppercase text-white stroke-black [text-shadow:1px_1px_0_rgb(5_46_118),-1px_-1px_0_rgb(5_46_118),-1px_1px_0_rgb(5_46_118),1px_-1px_0_rgb(5_46_118),0px_1px_0_rgb(5_46_118),0_-1px_0_rgb(5_46_118),-1px_0_0_rgb(5_46_118),1px_0_0_rgb(5_46_118);]'>{props.title}</h2>
            <h3 className='relative before:content-[""] before:absolute before:h-[1px] before:bg-primary before:w-full before:left-0 before:top-1/2 mt-2 font-bold text-4xl text-primary'><span className='relative px-8 md:px-16 bg-white'>{props.subTitle}</span></h3>
        </hgroup>
    )
}

export default Heading